import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ae1c810")

_pushScopeId("data-v-4ae1c810")
const _hoisted_1 = { class: "subscription-widget card mb-10 tableOpacity" }
const _hoisted_2 = { class: "card-p" }
const _hoisted_3 = { class: "details-header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "140",
  height: "24"
}, null, -1)
const _hoisted_5 = { class: "column-holder" }
const _hoisted_6 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "120",
  height: "18"
}, null, -1)
const _hoisted_7 = { class: "details-list" }
const _hoisted_8 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "70",
  height: "18"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "28",
  rx: ".25rem",
  ry: ".25rem",
  width: "160",
  height: "18"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_content_loader, {
          width: "100%",
          height: "24",
          speed: 2,
          primaryColor: "#929292",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
          return _createVNode("div", {
            class: "column",
            key: i
          }, [
            _createVNode("h3", null, [
              _createVNode(_component_content_loader, {
                width: "100%",
                height: "18",
                speed: 2,
                primaryColor: "#929292",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createVNode("ul", _hoisted_7, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (i) => {
                return _createVNode("li", { key: i }, [
                  _createVNode(_component_content_loader, {
                    width: "100%",
                    height: "46",
                    speed: 2,
                    primaryColor: "#929292",
                    secondaryColor: "#cccccc"
                  }, {
                    default: _withId(() => [
                      _hoisted_8,
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ])
              }), 64))
            ])
          ])
        }), 64))
      ])
    ])
  ]))
})